// Library → Featured from one index file instead of every guide_info doc
// (4.11.55). 766 Featured guide_info docs were ~2 MB over REST and 766 reads
// per open; the index (andiamoplaces.com/featured.json, built by
// scripts/buildFeaturedIndex.mjs after each batch and deployed with the web
// app) keeps only the fields the Featured list and its callers read —
// no wanderlist, and of the access list only the "All_*" entries (what makes a
// Featured guide readable/copyable for everyone; the owner is user_id, and
// personal shares stay out of a public file). Opening a guide still reads Firestore.
//   { v: 1, built: ISO, guides: [{ id, ...guide_info fields }] }
// Anything wrong with the file → null, and the caller falls back to the
// Firestore query.

export const FEATURED_INDEX_URL = "https://andiamoplaces.com/featured.json";

// The guide_info fields kept. Everything the Library, Build My Trip's
// "from guides" and Guides read for a Featured guide.
export const FEATURED_FIELDS = [
  "guide_name", "description", "cities", "countries", "base_location", "image", "image_m",
  "guide_id", "user_id", "creator_id", "owner_name", "type", "language", "share_all",
  "created", "mod", "read", "copy", "rating", "num_ratings", "times_read", "times_copied",
];

// guide_info docs ([{ id, data }]) → the index object.
export function toFeaturedIndex(docs, built) {
  const guides = (docs || [])
    .filter((d) => d && d.id && d.data && d.data.type === "Featured")
    .map((d) => {
      const g = { id: d.id };
      FEATURED_FIELDS.forEach((k) => { if (d.data[k] !== undefined) g[k] = d.data[k]; });
      g.access = (Array.isArray(d.data.access) ? d.data.access : []).filter((a) => /^All_[RCM]$/.test(a));
      return g;
    })
    .sort((a, b) => String(a.guide_name || "").localeCompare(String(b.guide_name || "")) || a.id.localeCompare(b.id));
  return { v: 1, built: built || new Date().toISOString(), guides };
}

// The index object → getAllGuideInfo's shape ([{ id, data }]), or null when
// it isn't a usable index (wrong version, empty, malformed).
export function fromFeaturedIndex(index) {
  if (!index || index.v !== 1 || !Array.isArray(index.guides) || index.guides.length === 0) return null;
  const out = [];
  for (const g of index.guides) {
    if (!g || typeof g.id !== "string" || !g.id) continue;
    const { id, ...data } = g;
    out.push({ id, data: { ...data, type: "Featured" } });
  }
  return out.length ? out : null;
}

// fetch the index; resolves [{ id, data }] or null (never rejects).
export async function loadFeaturedIndex(fetchFn = typeof fetch === "function" ? fetch : null, url = FEATURED_INDEX_URL, timeoutMs = 8000) {
  if (!fetchFn) return null;
  try {
    const timeout = new Promise((resolve) => setTimeout(() => resolve(null), timeoutMs));
    const res = await Promise.race([fetchFn(url, { cache: "no-cache" }), timeout]);
    if (!res || !res.ok) return null;
    return fromFeaturedIndex(await res.json());
  } catch (e) {
    return null;
  }
}
